// prompts.<area>.<key>: the suggested questions (services/platform-agent/platformAgentSuggestions.js), sent as typed.
// {{dish}} is a dish on the restaurant's menu, {{amount}} an amount in its currency (both from the picker).
export default {
  title: 'Hej {{first_name}}, hvad har du brug for til {{restaurant}}?',
  title_no_name: 'Hej, hvad har du brug for til {{restaurant}}?',
  text: 'Jeg kan svare på spørgsmål om {{restaurant}} og foretage ændringer for dig. Intet ændres, før du godkender det.',
  suggestions: 'Forslag',
  prompts: {
    reports: {
      top_dishes: 'Hvilke 10 retter solgte bedst sidste måned?',
      sales_vs_last_month: 'Hvordan var salget i forhold til sidste måned?',
    },
    menu: {
      raise_dish_price: 'Hæv prisen på {{dish}} med {{amount}}',
      dish_sold_out: 'Markér {{dish}} som udsolgt',
      dishes_without_photo: 'Hvilke retter har intet foto?',
    },
    hours: {
      holiday_hours: 'Ændr vores åbningstider den 24. december',
    },
    order_settings: {
      minimum_order: 'Hæv minimumsordren til {{amount}}',
    },
    marketing: {
      promo_code: 'Opret en rabatkode på 10 % til denne weekend',
    },
    my_info: {
      phone_number: 'Opdater vores telefonnummer',
    },
  },
};
